import { createRouter, createWebHistory } from "vue-router";
import { disposeTooltip } from '../assets/js/tooltip.js';
import Dashboard from "@/views/Dashboard.vue";
import BizLocations from "@/views/bizLocations";
import BizLocationList from "@/views/bizLocations/list";
import BizLocationDetail from "@/views/bizLocations/detail";
import ReadPoints from "@/views/readPoints";
import ReadPointList from "@/views/readPoints/list";
import ReadPointDetail from "@/views/readPoints/detail";
import RawMaterials from "@/views/rawMaterials";
import RawMaterialList from "@/views/rawMaterials/list";
import RawMaterialDetail from "@/views/rawMaterials/detail";
import Products from "@/views/products";
import ProductList from "@/views/products/list";
import ProductDetail from "@/views/products/detail";
import Vehicles from "@/views/vehicles";
import VehicleList from "@/views/vehicles/list";
import VehicleDetail from "@/views/vehicles/detail";

import EventCreate from "@/views/eventCreate";
import Prc1 from "@/views/eventCreate/EventPrc1.vue";
import Prc3 from "@/views/eventCreate/EventPrc3.vue";
import Prc4 from "@/views/eventCreate/EventPrc4.vue";
import Prc5 from "@/views/eventCreate/EventPrc5.vue";
import Prc6 from "@/views/eventCreate/EventPrc6.vue";
import Prc7 from "@/views/eventCreate/EventPrc7.vue";
import Prc8 from "@/views/eventCreate/EventPrc8.vue";
import Prc9 from "@/views/eventCreate/EventPrc9.vue";

import EventList from "@/views/components/eventList/table";
import EventSearch from "@/views/eventList/search";
import EventDetail from "@/views/eventList/detail";

import ProductTrace from "@/views/productTrace";
import ProductTraceTable from "@/views/components/productTrace/ProductTraceTable.vue";
import ProductTraceDetail from "@/views/productTrace/ProductTraceDetail.vue";
import MaterialTraceDetail from "@/views/productTrace/MaterialTraceDetail.vue";
import QrReadMap from "@/views/components/QrReadMap";

import Users from "@/views/users";
import UserList from "@/views/users/list.vue";
import UserDetail from "@/views/users/detail.vue";
import Manufacturer from "@/views/manufacturer";
import ManufacturerDetail from "@/views/manufacturer/detail.vue";
import WebLogList from "@/views/components/webLogs/table";
import WebLogSearch from "@/views/webLogs/search";
import WebLogDetail from "@/views/webLogs/detail";

import EventSave from "@/views/EventSave.vue";
import SelGroup from "@/views/SelGroup.vue";
import SelMf from "@/views/SelMf.vue";
import SignIn from "@/views/SignIn.vue";
import SignUp from "@/views/SignUp.vue";

import NotFound from "@/views/NotFound.vue";
import Error500 from '@/views/Error500.vue';
import Error403 from '@/views/Error403.vue';

import DataGen from "@/views/dataGen";

import store from '@/store'
 
const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/sign-in",
  },
  {
    path: "/dataGen",
    name: "DataGen",
    component: DataGen,
    meta: {
      pageTitle: '데이터 생성 - 데이터 생성',
      subtitle: '데이터 생성합니다.'
    },
  },
  {
    path: "/sel-group",
    name: "SelGroup",
    component: SelGroup,
    meta: {
      fullBleed: true,
      noTransition: true, 
    },
  },
  {
    path: "/sel-mf",
    name: "SelMf",
    component: SelMf,
    meta: {
      fullBleed: true,
      noTransition: true, 
    },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      pageTitle: '메인 - 대시보드',
      subtitle: '주요 지표와 최근 제품 정보를 요약합니다.'
    },
  },
  {
    path: "/bizLocations",
    name: "BizLocations",
    component: BizLocations,
    meta: {
      pageTitle: '데이터 관리 - 업무장소',
      subtitle: '업무가 이루어지는 현장의 위치와 정보를 관리합니다.'
    },
  },
  {
    path: "/bizLocations",
    component: BizLocations,
    meta: {
      pageTitle: '데이터 관리 - 업무장소',
      subtitle: '업무가 이루어지는 현장의 위치와 정보를 관리합니다.'
    },
    children: [
      {
        path: "",
        name: "BizLocations",
        component: BizLocationList,
      },
      {
        path: "new",
        name: "BizLocationCreate",
        component: BizLocationDetail,
        props: () => ({ mode: "create" }),
        meta: { pageTitle: "데이터 관리 - 업무장소" },
      },
      {
        path: ":id",
        name: "BizLocationEdit",
        component: BizLocationDetail,
        props: route => ({ id: route.params.id, mode: "edit" }),
        meta: { pageTitle: "데이터 관리 - 업무장소" },
      },
    ],
  },
  {
    path: "/readPoints",
    component: ReadPoints,
    meta: {
      pageTitle: '데이터 관리 - 스캔장소',
      subtitle: '제품 스캔이 발생한 장소를 등록하고 추적합니다.'
    },
    children: [
      {
        path: "",
        name: "ReadPoints",
        component: ReadPointList,
      },
      {
        path: "new",
        name: "ReadPointCreate",
        component: ReadPointDetail,
        props: () => ({ mode: "create" }),
        meta: { pageTitle: "데이터 관리 - 스캔장소" },
      },
      {
        path: ":id",
        name: "ReadPointEdit",
        component: ReadPointDetail,
        props: route => ({ id: route.params.id, mode: "edit" }),
        meta: { pageTitle: "데이터 관리 - 스캔장소" },
      },
    ],
  },
  {
    path: "/rawMaterials",
    component: RawMaterials,
    meta: {
      pageTitle: '데이터 관리 - 재료관리',
      subtitle: '생산·제조에 사용되는 원재료의 정보를 관리합니다.'
    },
    children: [
      {
        path: "",
        name: "RawMaterials",
        component: RawMaterialList,
      },
      {
        path: "new",
        name: "RawMaterialCreate",
        component: RawMaterialDetail,
        props: () => ({ mode: "create" }),
        meta: { pageTitle: "데이터 관리 - 재료관리" },
      },
      {
        path: ":id",
        name: "RawMaterialEdit",
        component: RawMaterialDetail,
        props: route => ({ id: route.params.id, mode: "edit" }),
        meta: { pageTitle: "데이터 관리 - 재료관리" },
      },
    ],
  },
  {
    path: "/products",
    component: Products,
    meta: {
      pageTitle: '데이터 관리 - 제품정보',
      subtitle: '제품의 기본 정보와 속성을 확인하고 수정합니다.'
    },
    children: [
      {
        path: "",
        name: "Products",
        component: ProductList,
      },
      {
        path: "new",
        name: "ProductCreate",
        component: ProductDetail,
        props: () => ({ mode: "create" }),
        meta: { pageTitle: "데이터 관리 - 제품정보" },
      },
      {
        path: ":id",
        name: "ProductEdit",
        component: ProductDetail,
        props: route => ({ id: route.params.id, mode: "edit" }),
        meta: { pageTitle: "데이터 관리 - 제품정보" },
      },
    ],
  },
  {
    path: "/vehicle",
    component: Vehicles,
    meta: {
      pageTitle: '데이터 관리 - 운송수단',
      subtitle: '물류 운송수단 정보를 관리합니다.'
    },
    children: [
      {
        path: "",
        name: "Vehicles",
        component: VehicleList,
      },
      {
        path: "new",
        name: "VehicleCreate",
        component: VehicleDetail,
        props: () => ({ mode: "create" }),
        meta: { pageTitle: "데이터 관리 - 운송수단" },
      },
      {
        path: ":id",
        name: "VehicleEdit",
        component: VehicleDetail,
        props: route => ({ id: route.params.id, mode: "edit" }),
        meta: { pageTitle: "데이터 관리 - 운송수단" },
      },
    ],
  },
  {
    path: "/eventCreate",
    component: EventCreate,
    meta: {
      pageTitle: 'EPCIS 이벤트 - 이벤트 생성',
      noTransition: true,
      subtitle: '제품의 생산·제조·운송 이벤트를 생성하고 관리합니다.'
    },
    children: [
      {
        path: 'prc1',
        component: Prc1,
      },
      {
        path: 'prc3', 
        component: Prc3,
      },
      {
        path: 'prc4', 
        component: Prc4,
      },
      {
        path: 'prc5', 
        component: Prc5,
      },
      {
        path: 'prc6', 
        component: Prc6,
      },
      {
        path: 'prc7', 
        component: Prc7,
      },
      {
        path: 'prc8', 
        component: Prc8,
      },
      {
        path: 'prc9', 
        component: Prc9,
      },
      {
        path: '', 
        name: "EventCreate",
        redirect: '/eventCreate/prc1',
      },
    ],
  },
  {
    path: "/eventList",
    component: EventSearch,
    meta: {
      pageTitle: 'EPCIS 이벤트 - 이벤트 조회',
      subtitle: 'EPCIS 이벤트를 조건별로 조회하고 상세 흐름을 추적합니다.',
      keepParentOnChildRoute: true,
    },
    children: [
      {
        path: "",
        name: "EventList",
        component: EventList,
        meta: { keepAlive: true },
      },
      {
        path: "detail/:id",
        name: "EventDetail",
        component: EventDetail,
        props: true,
      },
    ],
  },
  {
    path: "/productTrace",
    component: ProductTrace,
    meta: {
      pageTitle: '제품 추적 및 조회 - 제품이력 조회',
      subtitle: '제품의 생산부터 유통까지 전 과정을 조회합니다.'
    },
    children: [
      {
        path: 'table',
        component: ProductTraceTable,
      },
      {
        path: 'detail',
        component: ProductTraceDetail,
      },
      {
        path: 'material',
        component: MaterialTraceDetail,
      },
      {
        path: 'qrReadMap/:urn',
        name: 'QrReadMap',
        component: QrReadMap,
        props: true,
        meta: { fullBleed: true, noTransition: true, isMap: true }
      },
      {
        path: '', 
        name: "ProductTrace",
        redirect: '/productTrace/table',
      },
    ],
  },
  {
    path: "/users",
    component: Users,
    meta: {
      pageTitle: "시스템 관리 - 사용자 관리",
      subtitle: "이용중인 사용자 계정과 권한을 관리합니다.",
      requiresRole: ['ROLE_ADMIN','ROLE_SYSTEM'],
    },
    children: [
      {
        path: "",
        name: "Users",
        component: UserList,
      },
      {
        path: "new",
        name: "UserCreate",
        component: UserDetail,
        props: () => ({ mode: "create" }),
        meta: { pageTitle: "시스템 관리 - 사용자 관리" },
      },
      {
        path: ":id",
        name: "UserEdit",
        component: UserDetail,
        props: route => ({ id: route.params.id, mode: "edit" }),
        meta: { pageTitle: "시스템 관리 - 사용자 관리" },
      },
    ],
  },
  {
    path: "/manufacturer",
    component: Manufacturer,
    meta: {
      pageTitle: "시스템 관리 - 제조사 관리",
      subtitle: "현재 사용자의 제조사 정보를 관리합니다.",
      requiresRole: ['ROLE_ADMIN','ROLE_SYSTEM'],
    },
    children: [
      {
        path: "",
        name: "Manufacturer",
        component: ManufacturerDetail,
      },
    ],
  },
  {
    path: "/webLog",
    component: WebLogSearch,
    meta: {
      pageTitle: "시스템 관리 - 접속이력 관리",
      subtitle: "사용자 접속이력을 조회할 수 있습니다.",
      requiresRole: ['ROLE_ADMIN','ROLE_SYSTEM'],
      keepParentOnChildRoute: true,
    },
    children: [
      {
        path: "",
        name: "WebLogList",
        component: WebLogList,
        meta: { keepAlive: true },
      },
      {
        path: "detail/:id",
        name: "WebLogDetail",
        component: WebLogDetail,
        props: true,
      },
    ],
  },
  {
    path: "/eventSave",
    name: "EventSave",
    component: EventSave,
    meta: {
      pageTitle: '이벤트 생성',
    },
  },
  {
    path: "/mypage",
    component: Users,
    meta: {
      pageTitle: " - 프로필 수정",
      subtitle: "현재 사용자 계정과 권한을 관리합니다.",
    },
    children: [
      {
        path: ":id",
        name: "Profile",
        component: UserDetail,
        props: route => ({ id: route.params.id, mode: "edit", myPage: true }),
        meta: { pageTitle: " - 프로필 수정" },
      },
    ],
  },
  {
    path: "/sign-in",
    name: "Sign In",
    component: SignIn,
    meta: {
      fullBleed: true,
      noTransition: true, 
    },
  },
  {
    path: "/sign-up",
    name: "Sign Up",
    component: SignUp,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: { 
      fullBleed: true, 
      noTransition: true 
    }
  },
  {
    path: '/403',
    name: 'Error403',
    component: Error403,
    meta: { fullBleed: true, noTransition: true }
  },
  {
    path: '/error',
    name: 'Error500',
    component: Error500,
    meta: { fullBleed: true, noTransition: true }
  }

];

const TOKEN_KEY = "jwtToken";
let refreshing = null;

function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
}
function parseJwt(token) {
  try {
    const base64 = token.split(".")[1]
      .replace(/-/g, "+").replace(/_/g, "/")
      .padEnd(Math.ceil(token.split(".")[1].length / 4) * 4, "=");
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

async function refreshTokenIfNeeded(token) {
  const NEAR_EXPIRY = 300;
  if (!token) return null;
  const payload = parseJwt(token);
  if (!payload) return null;

  const now = Math.floor(Date.now() / 1000);
  const remain = payload.exp - now;
  if (remain > NEAR_EXPIRY) return token;

  if (refreshing) return refreshing;

  refreshing = (async () => {
    try {
      const res = await fetch("/api/auth/refresh", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({})
      });
      if (!res.ok) throw new Error("refresh failed");
      const data = await res.json();
      const newToken =
        data?.jToken || data?.jwtToken || data?.accessToken || data?.token;
      if (!newToken) throw new Error("no token");
      setToken(newToken);
      return newToken;
    } catch (e) {
      localStorage.removeItem(TOKEN_KEY);
      return null;
    } finally {
      refreshing = null;
    }
  })();

  return refreshing;
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
  scrollBehavior(to, from) {
    return { left: 0, top: 0 };
  },
});

// 공개 라우트(인증 불필요)
const PUBLIC_PATHS = ["/", "/sign-in"];
// 인증 체크 제외할 경로 접두어
const PUBLIC_PREFIXES = ["/productTrace"]; // "/productTrace", "/productTrace/..." 모두 매칭

router.beforeEach(async (to, from, next) => {
  try {
    // 0) 접두어 예외: /productTrace로 시작하면 무조건 통과
    if (PUBLIC_PREFIXES.some(prefix => to.path === prefix || to.path.startsWith(prefix + "/"))) {
      return next();
    }

    let token = getToken();

    // 1) 이미 로그인 상태에서 로그인/루트로 가면 대시보드로
    if (token && (to.path === "/" || to.path === "/sign-in")) {
      return next("/dashboard");
    }

    // 2) 공개 라우트면 통과 (토큰 있으면 갱신만 시도)
    if (PUBLIC_PATHS.includes(to.path)) {
      if (token) await refreshTokenIfNeeded(token);
      return next();
    }

    // 3) 보호 라우트: 토큰 없으면 로그인으로
    if (!token) {
      return next({ path: "/sign-in", query: { redirect: to.fullPath } });
    }

    // 4) 토큰 만료 임박/만료 시 새로고침
    const refreshed = await refreshTokenIfNeeded(token);
    token = refreshed || getToken();

    // 5) 새로고침 실패 → 로그인으로
    if (!token) {
      return next({ path: "/sign-in", query: { redirect: to.fullPath } });
    }

    const need = to.meta?.requiresRole;
    if (!need) return next();
    const role = store.getters['UserStore/getUserInfo']?.groupNm;
    if (!need.includes(role)) next({ name: 'Error403' });

    // 6) 정상 통과
    return next();
  } catch {
    // 예외 시 안전하게 로그인으로
    return next({ path: "/sign-in", query: { redirect: to.fullPath } });
  }
});


router.afterEach(() => {
  disposeTooltip();
});

export default router;
